import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const token = sessionStorage.getItem('token');
  const role = sessionStorage.getItem('role');

  if (!token) {
    router.navigate(['/signin']);
    return false;
  }

  const allowedRoles: string[] = (route.data?.['roles'] || []).map((r: string) => r.toLowerCase());
  if (allowedRoles.length && (!role || !allowedRoles.includes(role.trim().toLowerCase()))) {
    router.navigate(['/home']);
    return false;
  }

  if (route.data?.['powerUserOnly'] && sessionStorage.getItem('isPowerUser') !== 'true') {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
